import { TokenBodyParser } from '../token-parser';
import { jsonParseFromBase64 } from '../../utils/bytes-utils';
export class Ed25519TokenBodyParser extends TokenBodyParser {
    parse(base64Body) {
        return jsonParseFromBase64(base64Body);
    }
}
//# sourceMappingURL=ed25519-token-body-parser.js.map